"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@dynamynd/core");

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

exports.ModalContainer = styled_components_1.default(function (_a) {
  var visible = _a.visible,
      activeBreakpoint = _a.activeBreakpoint,
      scrollable = _a.scrollable,
      rest = __rest(_a, ["visible", "activeBreakpoint", "scrollable"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 99999;\n    width: 100%;\n    font-family: Roboto, sans-serif;\n    ", "\n"], ["\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 99999;\n    width: 100%;\n    font-family: Roboto, sans-serif;\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      visible = _a.visible,
      theme = _a.theme,
      height = _a.height,
      scrollable = _a.scrollable;
  var small = responsive_1.isSmall(activeBreakpoint);
  return "\n            overflow: " + (scrollable ? 'auto' : 'hidden') + ";\n            display: " + (visible ? 'block' : 'none') + ";\n            height: " + height + "px;\n            padding: " + (small ? core_1.GutterSizeEnum.small : core_1.GutterSizeEnum.wide) + "px;\n            background-color: " + theme.colors.white + ";\n        ";
});
var contentWidthsByBreakPoint = {
  extraLarge: '60%',
  large: '80%',
  medium: '80%',
  small: '100%'
};
exports.PageModalContentContainer = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: ", ";\n    margin: 0 auto;\n    padding-right: 10px;\n"], ["\n    width: ", ";\n    margin: 0 auto;\n    padding-right: 10px;\n"])), function (props) {
  return contentWidthsByBreakPoint[props.activeBreakpoint];
});
var templateObject_1, templateObject_2;